import React, {useEffect, useState} from "react";
import {Button, Divider, Grid, TextField, Typography} from "@mui/material";
import ProfileStyles from "../../styles/userProfile.module.css";
import {updateUserProfile} from "../../network/apis/user.api";
import {useProfile} from "../../context/userContext";
import {FormControlLabel, Checkbox} from "@mui/material";

const ContactAndFAADetails = ({token, onUpdateProfile}) => {
    const {profile, fetchProfile} = useProfile();
    const [phoneNumber, setPhoneNumber] = useState("");
    const [faaIDValue, setFaaIDValue] = useState("");
    const [marketingEmails, setMarketingEmails] = useState(false);
    const [notificationEmails, setNotificationEmails] = useState(false);
    const [isModified, setIsModified] = useState(false);
    const [updateStatus, setUpdateStatus] = useState("Update");
    const [phoneNumberError, setPhoneNumberError] = useState("");
    //const {fetchProfile} = useProfile(); // Access fetchProfile from context


    useEffect(() => {
        if (profile) {
            setPhoneNumber(profile.phoneNumber || "");
            setFaaIDValue(profile.faaIDValue || "");
            setMarketingEmails(profile.marketingEmails || false);
            setNotificationEmails(profile.notificationEmails || false);
        }
    }, [profile]);

    useEffect(() => {
        setIsModified(
            phoneNumber !== profile?.phoneNumber ||
            faaIDValue !== profile?.faaIDValue ||
            marketingEmails !== profile?.marketingEmails ||
            notificationEmails !== profile?.notificationEmails
        );
    }, [phoneNumber, faaIDValue, marketingEmails, notificationEmails, profile]);

    const handlePhoneNumberChange = (e) => {
        let value = e.target.value;
        if (!value.startsWith("+1")) {
            value = "+1" + value.replace(/^\+?[0-9]*/, "");
        }
        setPhoneNumber(value);

        const digits = value.replace(/\D/g, "");
        if (digits.length < 2 || digits.length > 15) {
            setPhoneNumberError("Phone number must be between 2 and 15 digits");
        } else {
            setPhoneNumberError("");
        }
    };

    const handleUpdate = async () => {
        try {
            const response = await updateUserProfile(token, profile.userId,
                phoneNumber,
                faaIDValue,
                marketingEmails,
                notificationEmails
            );
            if (response.status === 200) {
                setUpdateStatus("Update");
                await fetchProfile();
                // onUpdateProfile({
                //     ...profile,
                //     faaIDValue,
                //     phoneNumber,
                //     marketingEmails,
                //     notificationEmails
                // });
            } else {
                setUpdateStatus("Updating...");
                setIsModified(false);
            }
        } catch (error) {
            alert("An error occurred while updating profile details. Please try again later.");
        }
    };


    return (
        <div>
            <Typography className={ProfileStyles.section_header}>
                Contact & FAA Details
            </Typography>

            {/* Personal Contact Details Section */}
            <Typography variant="h6" className={ProfileStyles.sub_section_header}>
                Personal Contact Details
            </Typography>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                    <TextField
                        label="First Name"
                        value={profile?.firstName || "N/A"}
                        variant="outlined"
                        fullWidth
                        size="small"
                        disabled
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        label="Last Name"
                        value={profile?.lastName || "N/A"}
                        variant="outlined"
                        fullWidth
                        size="small"
                        disabled
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        label="Email"
                        value={profile?.email || "N/A"}
                        variant="outlined"
                        fullWidth
                        size="small"
                        disabled
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        label="Phone Number"
                        value={phoneNumber}
                        onChange={handlePhoneNumberChange}
                        variant="outlined"
                        fullWidth
                        size="small"
                        error={!!phoneNumberError}
                        helperText={phoneNumberError}
                    />
                </Grid>
            </Grid>

            <Divider className={ProfileStyles.section_divider} sx={{my: 2}}/>

            {/* FAA Details Section */}
            <Typography variant="h6" className={ProfileStyles.sub_section_header}>
                FAA License Details
            </Typography>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                    <TextField
                        label="FAA License Type"
                        value={profile?.faaIDType || "N/A"}
                        variant="outlined"
                        fullWidth
                        size="small"
                        disabled
                        helperText="Set during registration (Part 107 or 44809). Contact support to change."
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        label="FAA License ID"
                        value={faaIDValue}
                        onChange={(e) => setFaaIDValue(e.target.value)}
                        variant="outlined"
                        fullWidth
                        size="small"
                        placeholder="Enter your Remote Pilot Certificate or Trust Certificate ID"
                        helperText="Your FAA Remote Pilot Certificate number (Part 107) or Trust Certificate ID (44809)"
                    />
                </Grid>
            </Grid>

            <Divider className={ProfileStyles.section_divider} sx={{my: 2}}/>

            <Typography variant="h6" className={ProfileStyles.sub_section_header}>
                Email Preferences
            </Typography>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={marketingEmails}
                                onChange={(e) => setMarketingEmails(e.target.checked)}
                                color="primary"
                            />
                        }
                        label="Receive marketing emails"
                    />
                </Grid>
                <Grid item xs={12}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={notificationEmails}
                                onChange={(e) => setNotificationEmails(e.target.checked)}
                                color="primary"
                            />
                        }
                        label="Receive notification emails"
                    />
                </Grid>
            </Grid>

            <Button
                variant="contained"
                color="primary"
                onClick={handleUpdate}
                disabled={!isModified}
                style={{marginTop: "20px"}}
            >
                {updateStatus}
            </Button>
        </div>
    );
};

export default ContactAndFAADetails;